import { appConfig } from "../../system/types/app/appConfig";
import { language } from "../../system/types/project/language";

export enum SYSTEM_ACTIONS {
    systemToggleDarkTheme = 'SYSTEM_TOGGLE_DARK_THEME',
    systemSetLanguages = 'SYSTEM_SET_LANUGAGES',
    systemSetAppConfig = 'SYSTEM_SET_APP_CONFIG',
};

export type SystemState = {
    themeDark: boolean,
    languages: language[],
    appConfig: appConfig
};
